import React,{useState,useEffect,useContext,createContext,useRef} from 'react'
import { useParams,Navigate,useNavigate } from 'react-router-dom'
import axios from 'axios'
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  Avatar,
  TypingIndicator,
  Conversation,
  ConversationList,
  ConversationHeader
} from "@chatscope/chat-ui-kit-react";
import moment from 'moment'
import io from 'socket.io-client'
import {UserContext} from '../context/UserContext'
import Panel from '../ui/Panel'
import Btn from '../ui/Btn'
/* Aliased: the chat kit already exports a component called Avatar, and the
   bubbles keep using that one. The peer header is our own markup, so it uses
   the app's single face component. */
import UiAvatar from '../ui/Avatar'
import './chat.css'

/* public/user.png — stands in whenever a profile photo is missing, so the
   kit never renders a broken <img> inside a bubble. */
const FALLBACK_AVATAR='/user.png'

export default function ChatRoom() {
  const {isAuth,setIsAuth}=useContext(UserContext)
  const {apiToken,setApiToken} = useContext(UserContext)
  const [userID,setUserID ]= useState(sessionStorage.getItem('ChatUserUUID'))
  const {usrPhoto,setUsrPhoto}= useContext(UserContext)
  const {firstName,lastName}= useContext(UserContext)
  const [isLoading,setIsLoading]=useState(true)

  const [room,setRoom]=useState({})
  const [messages,setMessages]=useState([])
  const [messagesCheck,setMessagesCheck]=useState([])
  const [otherUserPhoto,setOtherUserPhoto]=useState('')
  const {socket,setSocket}=useContext(UserContext)
  const [isTyping,setIsTyping]=useState(false)
  const [currentMessage,setCurrentmessage]=useState('')
  const {loadUnreadMessages}=useContext(UserContext)
 // const [socketID,setSocketID]=useState('')
  const navigate=useNavigate()
  const {roomUUID}=useParams()

  /* Inline UI replaces alert()/console-only failures: roomError blocks the
     screen, sendError is a dismissible strip above the composer. */
  const [roomError,setRoomError]=useState(false)
  const [sendError,setSendError]=useState(false)


  useEffect(()=>{
    loadRoom()
    updateReadStatus()
    loadUnreadMessages(userID)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(()=>{

    socket.on("receive-message",(messageData)=>{
      setMessages((list)=>[...list,messageData])
      updateReadStatus()
    })

    socket.on("user-is-typing",UserWhoTypesUUID=>{
      //console.log("he's typing")
      if (UserWhoTypesUUID!==userID){
        setIsTyping(true)
      }

    })

    socket.on("user-stopped-typing",UserWhoTypesUUID=>{
      //console.log("he stoped")
      if (UserWhoTypesUUID!==userID){
        setIsTyping(false)
      }

    })

    return () => {
      socket.off('receive-message');
    };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[socket])

  useEffect(()=>{
    if (currentMessage.length>0){
      socket.emit('me-typing',userID,roomUUID)
    }else{
      socket.emit('me-stopped-typing',userID,roomUUID)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[currentMessage])


  const loadRoom=()=>{
    setIsLoading(true)
    axios.get(process.env.REACT_APP_API_SERVER+'manager/rooms/'+roomUUID+'/'+userID,{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
          }
      })
    .then(res=>{
      setRoom(res.data)
      setOtherUserPhoto(loadImage(res.data.ChatWithUUID))
      loadMessages()
      setIsLoading(false)
      setRoomError(false)
    }).catch(err=>{
        setIsLoading(false)
        setRoomError(true)

    })
  }

  const loadMessages=()=>{
    axios.get(process.env.REACT_APP_API_SERVER+'manager/messages/'+roomUUID,{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
          }
      })
    .then(res=>{
      //console.log(res.data.messages)
      setMessages(res.data.messages)
    }).catch(err=>{
        setIsLoading(false)
        setRoomError(true)

    })
  }

  const loadImage=(id)=>{
    const d=Date.now()
    return(`${process.env.REACT_APP_API_SERVER}files/${id}/${d}`)
  }



const messagesList=messages.map((item,index)=>{
  var sender=''
  var direction=''
  var avatar
  if (item.SenderUUID==userID){
    sender=firstName+ ' '+lastName
    direction='outgoing'
    avatar=usrPhoto
  }else{
    sender=room.ChatWithName
    direction='incoming'
    avatar=otherUserPhoto
  }
  const DTCreated=moment(item.DateCreated.split('T')[0]).format('DD/MM/YYYY')
  //+' '+item.DateCreated.split('T')[1].substr(0,5)

  return(

    <Message
      key={index}
      model={{
        message: item.Message,
        sentTime: item.DateCreated,
        sender,
        direction,
        position:'single'
      }}
    >
      <Message.Header sender={sender} sentTime={DTCreated} />
      <Avatar
            style={{

              objectFit:'cover'
            }}
        name={sender}
        src={avatar||FALLBACK_AVATAR}
        size="md"
      />

    </Message>

  )
})


const sendMessage=async (msg)=>{


  let currentDate = new Date();

  // Get the components of the date and time
  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1; // Months are zero-indexed
  let day = currentDate.getDate();
  let hours = currentDate.getHours();
  let minutes = currentDate.getMinutes();
  let seconds = currentDate.getSeconds();

  // Format the components as a string
  let formattedDate = year + '-' +
                      (month < 10 ? '0' + month : month) + '-' +
                      (day < 10 ? '0' + day : day) + ' ' +
                      (hours < 10 ? '0' + hours : hours) + ':' +
                      (minutes < 10 ? '0' + minutes : minutes) + ':' +
                      (seconds < 10 ? '0' + seconds : seconds);

  //alert('Current local date and time: ' + formattedDate);



  const obj={
    RoomUUID:roomUUID,
    SenderUUID:userID,
    ReceiverUUID:room.ChatWithUUID,
    Message:msg
  }
  setCurrentmessage('')
  await socket.emit("send-message",obj)

  axios.post(process.env.REACT_APP_API_SERVER+'manager/messages/',obj,{
    headers: {
        'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
        }
    })
  .then(res=>{
    //loadMessages()
    //setIsTyping(false)
    setIsLoading(false)
    setSendError(false)
  }).catch(err=>{
      setIsLoading(false)
      setSendError(true)

  })
}

const updateReadStatus=()=>{
  axios.get(process.env.REACT_APP_API_SERVER+'manager/messages/update/'+roomUUID+'/'+userID,{
    headers: {
        'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
        }
    })
  .then(res=>{
    //console.log(res.data.messages)
    //setMessages(res.data.messages)
  }).catch(err=>{
    console.log(err)
  })
}

  const meTyping=(msg)=>{
    setCurrentmessage(msg)
  }

  const peerName=room.ChatWithName?room.ChatWithName:'Conversation'
  const count=messages.length

  const heading=(
    <span className="chat-peer">
      <UiAvatar uuid={room.ChatWithUUID} name={peerName} size={30} />
      <span className="chat-peer-name">{peerName}</span>
    </span>
  )

  const status=(
    <span className={isTyping?'chat-status':'chat-status is-off'}>
      <span className="chat-dot"></span>
      {isTyping
        ?'Typing'
        :(count===1?'1 message':count+' messages')}
    </span>
  )

  return (
    <div className="chat-page">

      <Panel
        className="chat-panel"
        title={isLoading?'Loading conversation':heading}
        subtitle={isLoading?'Fetching the room and its history':'Direct message'}
        actions={isLoading?null:status}
      >

        {roomError
          ?<div className="chat-notice is-error">
              <span className="chat-notice-row">
                <span><b>This conversation could not be loaded.</b> The room or its history did not come back from the server.</span>
                <Btn onClick={()=>{ setRoomError(false); loadRoom() }}>Try again</Btn>
              </span>
            </div>
          :null}

        {!roomError&&sendError
          ?<div className="chat-notice is-error">
              <span className="chat-notice-row">
                <span><b>Your last message was not saved.</b> It was delivered live, but it will not be in the history — send it again.</span>
                <Btn onClick={()=>setSendError(false)}>Dismiss</Btn>
              </span>
            </div>
          :null}

        {isLoading
          ?<div className="chat-sk" aria-hidden="true">
              <span className="skeleton sk-in"></span>
              <span className="skeleton sk-out"></span>
              <span className="skeleton sk-in sk-short"></span>
              <span className="skeleton sk-out"></span>
            </div>
          :null}

        {!isLoading&&!roomError
          ?<div className="chatx">
              <MainContainer>

                <ChatContainer>
                  <MessageList typingIndicator={isTyping ? <TypingIndicator content={peerName+' is typing'}/> : null}>
                      {messagesList}
                  </MessageList>

                  <MessageInput value={currentMessage} onChange={(e)=>meTyping(e)}  placeholder="Type message here" attachButton={false} onSend={(msg)=>sendMessage(msg)}/>
                </ChatContainer>

              </MainContainer>

            </div>
          :null}

      </Panel>

    </div>
  )
}
